import { Box, Container, useTheme } from '@mui/material';

import { useCohortEditable } from '@verantos-dev/app-state-cohort-builder';
import { useCohortBuilderData } from '@verantos-dev/data-access-cohorts';
import { ResearchAssistantChatWindow } from '@verantos-dev/feature-research-assistant';
import { CohortStatusLegacy } from '@verantos-dev/types-cohorts';

import { ResearchAssistantTabbedArea } from './ResearchAssistantTabbedArea';

export const ResearchAssistantTabContent = () => {
  const theme = useTheme();
  const { data: cohortData } = useCohortBuilderData();
  const { isEditable, isCohortVersionLoading } = useCohortEditable();
  const allowMessageSubmit =
    !!cohortData?.data.latestStatus &&
    ![CohortStatusLegacy.FINAL, CohortStatusLegacy.PROCESSING].includes(
      cohortData?.data.latestStatus as unknown as CohortStatusLegacy
    );

  return (
    <Container
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        width: '100%',
        margin: '0',
        height: 'calc(100vh - 200px)',
        padding: theme.spacing(2),

        '&.MuiContainer-root': {
          '@media (min-width: 1200px)': {
            maxWidth: 'none',
            margin: '0',
          },
          '@media (min-width: 600px)': {
            margin: '0',
          },
        },
      }}
    >
      <ResearchAssistantTabbedArea isCohortVersionLoading={isCohortVersionLoading} />

      <Box>
        <ResearchAssistantChatWindow
          toggleAssistant={undefined}
          isOwner={isEditable}
          allowMessageSubmit={allowMessageSubmit}
        />
      </Box>
    </Container>
  );
};
